import { Localizations } from '@eig-builder/module-localization'

Localizations.append({
  modules: {
    crm: {
      components: {
        account: {
          addCredits: {
            title: 'Add Credits to Account',
            cancel: 'Cancel',
            confirm: 'Add credit',
            labels: {
              amount: 'Credit amount',
              description: 'Description',
              type: 'Type',
              sendNote: 'Send credit note'
            },
            amountError:
              "We're sorry, you're unable to issue this credit. Please reach out to your manager for assistance."
          },
          credits: 'Credits',
          downgradeAccount: {
            title: 'Downgrade to free',
            loadingRegisteredDomains: 'Checking for registered domains...',
            registeredDomains: 'The customers has registered domain names. Please select which domains the customer would like to keep and transfer away.',
            noRegisteredDomains: 'No registered domains where found for this account.',
            error: 'Something went wrong while downgrading the account.',
            success: 'The account has been downgraded.',
            refundServices: 'Services have been refunded'
          },
          cancelAccount: {
            title: 'Cancel account',
            description: 'You are about to cancel the account. Filling in the reason field is required before being able to submit. Performing this action may take up to a minute to apply.',
            blacklist: 'Blacklist site subdomain(s) to prevent future usage of that subdomain',
            error: 'Something went wrong while cancelling the account.',
            success: 'The account has been cancelled.'
          },
          changeEmail: {
            title: 'Change email',
            warning: 'WARNING',
            warningInfo: 'Changing this email address will change how the customer logs in to their account.',
            info: 'The user email cannot be changed to something that is already being used by another account of the same brand.',
            note: 'NOTE',
            noteInfo: 'If the customer has SiteLock, please tell the customer to login to SiteLock to change the contact email adress manually.'
          },
          changeName: {
            title: 'Change name',
            firstName: 'New first name',
            lastName: 'New last name'
          },
          accountRelink: {
            title: 'Account Relink',
            cancel: 'Cancel',
            confirm: 'Confirm',
            labels: {
              accountId: 'Account Id',
              currentSoid: 'Current soID',
              destinationSoid: 'Destination soID',
              destinationUserId: 'Destination User Id (guid)'
            }
          },
          reason: 'Reason',
          cancelReason: 'Reason for cancellation',
          downgradeReason: 'Reason for downgrading',
          sendEmailDowngrade: 'Send an email to the customer containing details about the downgrade to free',
          cancel: 'Cancel',
          submit: 'Submit',
          close: 'Close'
        }
      }
    }
  }
})
